import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h4 className="font-heading text-xl font-bold text-background-50 mb-4">
                {siteConfig.name}
              </h4>
              <p className="text-sm text-background-300 leading-relaxed">
                {siteConfig.description}
              </p>
            </div>

            <div>
              <h4 className="font-medium text-background-50 mb-4 text-sm">快速导航</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/football" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                    赛事分类
                  </Link>
                </li>
                <li>
                  <Link to="/article/app-download-guide" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                    下载教程
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-medium text-background-50 mb-4 text-sm">热门分类</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/category/football" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                    足球赛事
                  </Link>
                </li>
                <li>
                  <Link to="/category/basketball" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                    篮球赛事
                  </Link>
                </li>
                <li>
                  <Link to="/category/esports" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                    电子竞技
                  </Link>
                </li>
                <li>
                  <Link to="/category/tennis" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                    网球赛事
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-medium text-background-50 mb-4 text-sm">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                  service@kaiyunsports.com
                </li>
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                  400-888-6666
                </li>
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                  7x24小时服务
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {currentYear} {siteConfig.name} 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}